import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";

const RelatedGamesModuleAsyncComponent = AsyncComponent(async () => import('./related-games-module' /* webpackChunkName: "related-games-module" */ ));

export const RelatedGamesModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <RelatedGamesModuleAsyncComponent {...props}/>
  </React.Suspense>
};
